
/**
 * @module
 * @name chartTable
 */
export default {
  name: 'chartTable',
  props: {
    dataTableChart: {
      type: Array | Object
    }
  }
}
